/*
 * LoaderComponent
 *
 * Loader component is common for all the pages for showing loading indecator
 *
 */

import React, { Component } from 'react';
import { Button, Modal } from 'react-bootstrap';
import '../css/loader.css';

export default class ErrorComponent extends Component {
    render() {
        return (
            <Modal show={this.props.show} backdrop="static"
                keyboard={false} contentClassName="loader-modal-size modal-content-error" centered="true">
                
                <Modal.Header className="modal-header-error">
                    <Modal.Title className="modal-title-error">{this.props.heading}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="d-flex align-items-center justify-content-center" style={{ 'height': '90%', 'width': '100%', 'flexDirection': 'column' }}>
                        <div>{this.props.message}</div>
                    </div>
                </Modal.Body>

                <Modal.Footer className="beck-modal-footer">
                    <Button variant="primary" size="lg" onClick={this.props.handleClose}>OK</Button>
                </Modal.Footer>

            </Modal>
        );
    }
}